import { CommonEnums } from '../../common.enums';
import { RestJob_Inst } from './restjob_inst';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { RepConn } from '../datapoint/repconn';
import { Obj_Db_PropertyUtil } from 'src/app/shared/utils/obj_db_property.util';
import { Param } from 'src/app/shared/models/domain/param';
import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { Conn_Db_Obj_LnksUtil } from 'src/app/shared/utils/conn_db_obj_lnks.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { ParamsUtil } from '../utils/params.util';

export class RestJob {
    restJob_Inst: RestJob_Inst;
    param_Properties: Array<Obj_Db_Property>;
    rest_Properties: Array<Obj_Db_Property>;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    file_Properties: Array<Obj_Db_Property>;
    header_Properties: Array<Obj_Db_Property>;
    pagination_Properties: Array<Obj_Db_Property>;
    input_Properties: Array<Obj_Db_Property>;
    reRun_Properties: Array<Obj_Db_Property>;
    parameters: Array<Param>;
    decryption_Properties: Array<Obj_Db_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    repConn: RepConn;
    showRestParamsHeaders: string; //readonly
    showResParamsTab: string; //readonly
    sel_File_PropertyType_Cd: string;
    sel_Param_PropertyType_Cd: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.restJob_Inst = new RestJob_Inst();
        this.param_Properties = new Array<Obj_Db_Property>();
        this.rest_Properties = new Array<Obj_Db_Property>();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.file_Properties = new Array<Obj_Db_Property>();
        this.header_Properties = new Array<Obj_Db_Property>();
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.repConn = new RepConn();
        this.pagination_Properties = Array<Obj_Db_Property>();
        this.input_Properties = Array<Obj_Db_Property>();
        this.reRun_Properties = Array<Obj_Db_Property>();
        this.parameters = Array<Param>();
        this.decryption_Properties = Array<Obj_Db_Property>();
        this.showRestParamsHeaders = CommonEnums.defaults.BOOLEAN_VAL;
        this.showResParamsTab = CommonEnums.defaults.BOOLEAN_VAL;
        this.sel_File_PropertyType_Cd = '';
        this.sel_Param_PropertyType_Cd = '';
    }

    static parse(restJobTmp: RestJob): RestJob {
        let restJob: RestJob = new RestJob();
        restJob.copyFrom(restJobTmp);
        return restJob;
    }

    copy(): RestJob {
        let restJobTmp: RestJob = new RestJob();

        restJobTmp.restJob_Inst = this.restJob_Inst.copy();
        restJobTmp.param_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.param_Properties);
        restJobTmp.rest_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.rest_Properties);
        restJobTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        restJobTmp.file_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.file_Properties);
        restJobTmp.header_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.header_Properties);
        restJobTmp.change_Ind = this.change_Ind;
        restJobTmp.error_Cd = this.error_Cd;
        restJobTmp.error_Msg = this.error_Msg;
        restJobTmp.ref_Id = this.ref_Id;
        restJobTmp.ref_Cd = this.ref_Cd;
        restJobTmp.fldr_Id = this.fldr_Id;
        restJobTmp.repConn = this.repConn.copy();
        restJobTmp.pagination_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.pagination_Properties);
        restJobTmp.input_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.input_Properties);
        restJobTmp.reRun_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.reRun_Properties);
        restJobTmp.parameters = ParamsUtil.getInstance().copy(this.parameters);
        restJobTmp.decryption_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.decryption_Properties);
        restJobTmp.showRestParamsHeaders = this.showRestParamsHeaders;
        restJobTmp.showResParamsTab = this.showResParamsTab;
        restJobTmp.sel_File_PropertyType_Cd = this.sel_File_PropertyType_Cd;
        restJobTmp.sel_Param_PropertyType_Cd = this.sel_Param_PropertyType_Cd;

        return restJobTmp;
    }

    copyFrom(restJobTmp: RestJob): void {

        this.restJob_Inst.copyFrom(restJobTmp.restJob_Inst);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.param_Properties, restJobTmp.param_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.rest_Properties, restJobTmp.rest_Properties);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, restJobTmp.conn_Db_Obj_Lnks);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.header_Properties, restJobTmp.header_Properties);
        this.change_Ind = restJobTmp.change_Ind;
        this.error_Cd = restJobTmp.error_Cd;
        this.error_Msg = restJobTmp.error_Msg;
        this.ref_Id = restJobTmp.ref_Id;
        this.ref_Cd = restJobTmp.ref_Cd;
        this.repConn.copyFrom(restJobTmp.repConn);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.pagination_Properties, restJobTmp.pagination_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.input_Properties, restJobTmp.input_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.reRun_Properties, restJobTmp.reRun_Properties);
        ParamsUtil.getInstance().copyFrom(this.parameters, restJobTmp.parameters);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.decryption_Properties, restJobTmp.decryption_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.file_Properties, restJobTmp.file_Properties);
        this.showRestParamsHeaders = restJobTmp.showRestParamsHeaders;
        this.showResParamsTab = restJobTmp.showResParamsTab;
        this.sel_File_PropertyType_Cd = restJobTmp.sel_File_PropertyType_Cd;
        this.sel_Param_PropertyType_Cd = restJobTmp.sel_Param_PropertyType_Cd;
    }

    compare(restJobTmp: RestJob): string {
        let diffString = '';

        diffString = this.restJob_Inst.compare(restJobTmp.restJob_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, restJobTmp.conn_Db_Obj_Lnks)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.file_Properties, restJobTmp.file_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.rest_Properties, restJobTmp.rest_Properties)
        if (diffString != '') return diffString;

        diffString = ParamsUtil.getInstance().compare(this.parameters, restJobTmp.parameters)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.input_Properties, restJobTmp.input_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.param_Properties, restJobTmp.param_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.pagination_Properties, restJobTmp.pagination_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.decryption_Properties, restJobTmp.decryption_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.reRun_Properties, restJobTmp.reRun_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.header_Properties, restJobTmp.header_Properties)
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        return "RestJob [restJob_Inst=" + this.restJob_Inst +
            ", param_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.param_Properties) +
            ", rest_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.rest_Properties) +
            ", file_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.file_Properties) +
            ", header_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.header_Properties) +
            ",decryption_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.decryption_Properties) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ",showResParamsTab=" + this.showResParamsTab +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ",sel_File_PropertyType_Cd=" + this.sel_File_PropertyType_Cd +
            ",showRestParamsHeaders=" + this.showRestParamsHeaders +
            ",sel_Param_PropertyType_Cd=" + this.sel_Param_PropertyType_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", repConn=" + this.repConn +
            ", pagination_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.pagination_Properties) +
            ", input_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.input_Properties) +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", reRun_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.reRun_Properties) +
            ",parameters=" + this.parameters + "]"
    }
}